<div>
@if (show) {
    <p-progressBar
    mode="indeterminate"
    [style]="{ height: '6px' }"            >
    </p-progressBar>
}
</div>



